var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3 border pl-3 pr-3 pt-2 pb-2",staticStyle:{"position":"relative"}},[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fas', 'times']},on:{"click":_vm.actionOnClose}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }